export type WorkCategory = '校园' | '同居' | '暧昧' | '逆后宫';

export interface AnimeWork {
  id: string;
  title: string;
  category: WorkCategory;
  tags: string[];
  rating: number;
  chapters: number;
  year: number;
  desc: string;
  cover: string;
  hot?: boolean;
}

export const works: AnimeWork[] = [
  {
    id: 'campus-01',
    title: '同桌的她有点不一样',
    category: '校园',
    tags: ['同桌', '青涩', '慢热'],
    rating: 9.2,
    chapters: 128,
    year: 2022,
    desc: '高二分班后，男主角与新同桌的日常从相看两厌到慢慢靠近，一场关于青春、误解与心动的校园恋爱就此展开。',
    cover: 'https://readdy.ai/api/search-image?query=soft%20romantic%20anime%20cover%20art%20of%20a%20high%20school%20boy%20and%20girl%20as%20deskmates%20in%20classroom%2C%20warm%20peach%20and%20rose%20palette%2C%20gentle%20spring%20light%2C%20shoujo%20manga%20style%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=work-campus-01&orientation=portrait',
    hot: true,
  },
  {
    id: 'campus-02',
    title: '社团活动室的秘密',
    category: '校园',
    tags: ['社团', '放学后', '会长'],
    rating: 8.8,
    chapters: 96,
    year: 2023,
    desc: '放学后空无一人的活动室，冷面学生会长的另一面逐渐展现，校园传说与恋爱交织的酸甜故事。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20school%20club%20room%20with%20a%20boy%20and%20serious%20student%20council%20president%20girl%20after%20school%2C%20warm%20golden%20afternoon%20light%2C%20romantic%20shoujo%20manga%20style%2C%20soft%20pastel%2C%20no%20text&width=600&height=800&seq=work-campus-02&orientation=portrait',
  },
  {
    id: 'campus-03',
    title: '图书馆的第三排座位',
    category: '校园',
    tags: ['图书馆', '安静', '双向暗恋'],
    rating: 9.0,
    chapters: 74,
    year: 2021,
    desc: '每个黄昏都在图书馆同一排座位相遇的两人，用眼神与纸条传递心意的安静校园恋曲。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20cover%20art%20of%20a%20boy%20and%20girl%20sitting%20at%20tables%20in%20a%20sunlit%20school%20library%2C%20warm%20rose%20and%20cream%20tones%2C%20shoujo%20romance%20manga%20style%2C%20soft%20lighting%2C%20no%20text&width=600&height=800&seq=work-campus-03&orientation=portrait',
  },
  {
    id: 'cohab-01',
    title: '合租屋的屋顶月光',
    category: '同居',
    tags: ['合租', '屋顶', '温馨'],
    rating: 9.4,
    chapters: 152,
    year: 2020,
    desc: '因房租问题与温柔房东开始同居生活，从客气的边界到不自觉的靠近，屋顶月光下的温暖日常。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20man%20and%20woman%20on%20a%20cozy%20apartment%20rooftop%20under%20moonlight%2C%20warm%20amber%20and%20rose%20palette%2C%20romantic%20shoujo%20manga%20style%2C%20soft%20glow%2C%20no%20text&width=600&height=800&seq=work-cohab-01&orientation=portrait',
    hot: true,
  },
  {
    id: 'cohab-02',
    title: '青梅竹马的同居协议',
    category: '同居',
    tags: ['青梅竹马', '协议', '日常'],
    rating: 8.9,
    chapters: 110,
    year: 2022,
    desc: '从小一起长大的青梅竹马，因工作变动临时同居，约法三章的背后是早已藏不住的心意。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20cover%20art%20of%20childhood%20friends%20boy%20and%20girl%20sharing%20a%20small%20apartment%20breakfast%20table%2C%20warm%20pastel%20tones%2C%20shoujo%20romance%20manga%20style%2C%20cozy%20domestic%20scene%2C%20no%20text&width=600&height=800&seq=work-cohab-02&orientation=portrait',
  },
  {
    id: 'cohab-03',
    title: '同居第七天的告白',
    category: '同居',
    tags: ['闪电同居', '告白', '心动'],
    rating: 8.7,
    chapters: 88,
    year: 2023,
    desc: '一次意外的合租邀约，把两个原本陌生的人推进了同一扇门，七天里边界感一点点崩塌。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20boy%20and%20girl%20moving%20boxes%20into%20a%20new%20shared%20apartment%2C%20warm%20rose%20and%20gold%20palette%2C%20shoujo%20romance%20manga%20style%2C%20soft%20lighting%2C%20no%20text&width=600&height=800&seq=work-cohab-03&orientation=portrait',
  },
  {
    id: 'ambi-01',
    title: '暧昧期的距离感',
    category: '暧昧',
    tags: ['暧昧', '拉扯', '成年'],
    rating: 9.1,
    chapters: 134,
    year: 2021,
    desc: '嘴上说着"只是朋友"，却总在细节里破功。成年职场里的暧昧拉扯，看谁先打破那层窗户纸。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20cover%20art%20of%20a%20professional%20man%20and%20woman%20close%20together%20in%20a%20city%20cafe%20at%20dusk%2C%20warm%20amber%20and%20rose%20tones%2C%20mature%20shoujo%20romance%20manga%20style%2C%20soft%20moody%20lighting%2C%20no%20text&width=600&height=800&seq=work-ambi-01&orientation=portrait',
    hot: true,
  },
  {
    id: 'ambi-02',
    title: '隔壁座位的秘密',
    category: '暧昧',
    tags: ['邻居', '推拉', '误会'],
    rating: 8.6,
    chapters: 92,
    year: 2023,
    desc: '深夜便利店的偶遇、递过的那把伞，让两个假装不认识的人开始了一场谁都不先开口的推拉。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20boy%20and%20girl%20under%20one%20umbrella%20on%20a%20rainy%20city%20night%2C%20warm%20rose%20and%20teal%20accent%2C%20shoujo%20romance%20manga%20style%2C%20soft%20glow%2C%20no%20text&width=600&height=800&seq=work-ambi-02&orientation=portrait',
  },
  {
    id: 'ambi-03',
    title: '暧昧同居日记',
    category: '暧昧',
    tags: ['同居', '暧昧', '双向'],
    rating: 9.0,
    chapters: 121,
    year: 2020,
    desc: '借住朋友家，却与朋友的哥哥产生了说不清道不明的默契。每天在同居日常里反复试探彼此心意。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20cover%20art%20of%20a%20girl%20and%20older%20brother%20figure%20in%20a%20cozy%20living%20room%20watching%20tv%20together%2C%20warm%20amber%20tones%2C%20shoujo%20romance%20manga%20style%2C%20soft%20domestic%20lighting%2C%20no%20text&width=600&height=800&seq=work-ambi-03&orientation=portrait',
  },
  {
    id: 'rev-01',
    title: '被五位男主包围的日子',
    category: '逆后宫',
    tags: ['逆后宫', '多男主', '抉择'],
    rating: 9.3,
    chapters: 168,
    year: 2019,
    desc: '从转学第一天起，女主角就不断被性格各异的优秀男主们包围。逆后宫题材的恋爱抉择与成长物语。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20cover%20art%20of%20one%20heroine%20surrounded%20by%20five%20handsome%20male%20leads%20in%20a%20school%20courtyard%2C%20warm%20rose%20and%20gold%20palette%2C%20reverse%20harem%20shoujo%20manga%20style%2C%20no%20text&width=600&height=800&seq=work-rev-01&orientation=portrait',
    hot: true,
  },
  {
    id: 'rev-02',
    title: '女神的守护骑士们',
    category: '逆后宫',
    tags: ['奇幻', '守护', '逆后宫'],
    rating: 8.8,
    chapters: 142,
    year: 2021,
    desc: '意外穿越到奇幻世界，成为被各大势力争相守护的女主角。在权谋与守护之间，谁才是真心？',
    cover: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20heroine%20in%20fantasy%20robes%20with%20several%20knight%20protectors%20in%20a%20mystical%20forest%2C%20warm%20gold%20and%20rose%20tones%2C%20fantasy%20reverse%20harem%20shoujo%20manga%20style%2C%20no%20text&width=600&height=800&seq=work-rev-02&orientation=portrait',
  },
  {
    id: 'rev-03',
    title: '学园首席的候补生',
    category: '逆后宫',
    tags: ['学园', '竞争', '青春'],
    rating: 8.5,
    chapters: 76,
    year: 2022,
    desc: '为了争夺唯一的名额，女主角在精英学园里与几位顶尖男主斗智斗勇，也在竞争中渐渐心动。',
    cover: 'https://readdy.ai/api/search-image?query=anime%20cover%20art%20of%20a%20determined%20heroine%20walking%20into%20an%20elite%20academy%20with%20male%20students%20around%2C%20warm%20rose%20and%20cream%20palette%2C%20school%20reverse%20harem%20shoujo%20manga%20style%2C%20no%20text&width=600&height=800&seq=work-rev-03&orientation=portrait',
  },
];

export const categories: WorkCategory[] = ['校园', '同居', '暧昧', '逆后宫'];

export const categoryIntro: Record<WorkCategory, string> = {
  校园: '发生在校园里的青春心动，从同桌、社团到图书馆，青涩又真诚的恋爱故事。',
  同居: '从合租到屋顶月光，在同一个屋檐下日渐靠近的温馨与悸动。',
  暧昧: '谁都不肯先开口的推拉拉扯，成年人的暧昧关系与隐秘心动。',
  逆后宫: '被性格各异的优秀男主们包围，女主角的恋爱抉择与成长物语。',
};